import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  TrainingCoursesDashboardClassApiModel,
  TrainingCoursesDashboardQuizInstanceApiModel,
  TrainingCoursesDashboardReportsApiModel,
  TrainingCoursesDashboardRequestsApiModel
} from '@app/api/api-models';
import { toQueryParams } from '@app/shared/utils';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class TrainingCoursesDashboardService {
  public apiUrl = 'training-courses-dashboard';

  constructor(private readonly http: HttpClientService) {}

  public getReports(all: boolean): Observable<TrainingCoursesDashboardReportsApiModel> {
    const params = toQueryParams({
      all: all
    });

    return this.http.get<TrainingCoursesDashboardReportsApiModel>(`${this.apiUrl}/reports`, { params: params });
  }

  public getRequests(all: boolean): Observable<TrainingCoursesDashboardRequestsApiModel> {
    const params = toQueryParams({
      all: all
    });

    return this.http.get<TrainingCoursesDashboardRequestsApiModel>(`${this.apiUrl}/requests`, { params: params });
  }

  public getQuizInstances(): Observable<TrainingCoursesDashboardQuizInstanceApiModel[]> {
    return this.http.get<TrainingCoursesDashboardQuizInstanceApiModel[]>(`${this.apiUrl}/quiz-instances`);
  }

  public getClasses(): Observable<TrainingCoursesDashboardClassApiModel[]> {
    return this.http.get<TrainingCoursesDashboardClassApiModel[]>(`${this.apiUrl}/classes`);
  }
}
